// HeroSection.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import backgroundVideo from '../assets/videos/background.mp4';
import underlineImage from '../assets/icons/line.svg';
import geoIcon from '../assets/icons/geo.svg';
import dataIcon from '../assets/icons/data1.svg';
import globeIcon from '../assets/icons/globe1.svg';
import ksaIcon from '../assets/icons/Ksa1.svg';
import ksaMap from '../assets/images/ksamapbeta.png';
import arrowRightIcon from '../assets/icons/arrow-right.svg';
import rectangle from'../assets/icons/rectangle.svg';
import gouv from'../assets/icons/Gov.svg';
import priv from '../assets/icons/Private.svg';
import data from '../assets/icons/dataicon.svg';
import academ from '../assets/icons/Academic.svg';
import webser from '../assets/icons/web.svg'
import geonames from '../assets/images/geonames.png'
import arrowGreen from '../assets/icons/arrow-green.svg'
import geocatalog from'../assets/images/geocatalog.png'
import opendata from '../assets/images/open-data.svg'
import geodesy from '../assets/images/geodesy.png'
import maritime from  '../assets/images/maritime.png'
import dtwin from  '../assets/images/digitalTwin.png'

function HeroSection() {
  const { t } = useTranslation();

  return (
    <>
      {/* Hero Section */}
      <section className="hero position-relative text-white">
        <video
          className="hero-video position-absolute w-100 h-100 object-fit-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div
          className="video-overlay position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: 'rgba(0, 45, 53, 0.5)' }}
        ></div>

        <div className="info container-fluid position-relative z-1 p-0 m-5">
          <div className="title-container">
            <h1 className="display-4 fw-bold m-0 d-inline">
              {t('national')}
            </h1>
            <span className="geospatial-container">
              <h1 className="display-4 fw-bold m-0 d-inline">
                {t('geospatial')}
              </h1>
              <img
                className="underline-image img-fluid mt-n4 mb-3"
                src={underlineImage}
                alt="underline"
              />
            </span>
          </div>
          <h1 className="display-4 fw-bold m-0 d-inline">
            {t('platform')}
          </h1>
          <h2
            className="h4 fw-medium mt-4"
            style={{ fontSize: '22px' }}
          >
            {t('hero_subtitle')}
          </h2>
          <p
            className="lead m-0"
            style={{ fontSize: '16px', fontWeight: 400, textAlign: 'justify' }}
          >
            {t('hero_paragraph')}
          </p>
          <Link className="nav-link" to="/AboutUs">
          <button className="btn btn-white mt-3" id="more">{t('about_us')} </button>
                  </Link>
          
        </div>
      </section>

      {/* Cards Container */}
      <div className="floating-cards">
        <div className="services bg-transparent">
          {/* Card 1 */}
          <div className="service-card p-4 text-center shadow-sm mb-4" id="datarequest">
            <img
              src={geoIcon}
              alt={t('geospatial_data_request')}
              className="card-icon img-fluid mb-3"
            />
            <h3 className="h5 fw-medium">{t('geospatial_data_request')}</h3>
            <p className="small" style={{ textAlign: 'justify' }}>
              {t('geospatial_data_request-subtitle')}
            </p>
            <a
              href={t('Geospatial-Data-Request-url')}
              className="card-link"
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="read-more d-flex align-items-center justify-content-center mt-3 text-muted">
                <p className="mb-0">{t('read-more')}</p>
                <img src={arrowRightIcon} className="ms-2" alt="arrow right" />
              </div>
            </a>
          </div>

          {/* Card 2 */}
          <div className="service-card p-4 text-center shadow-sm mb-4" id="opendata">
            <img
              src={dataIcon}
              alt={t('open_data')}
              className="card-icon img-fluid mb-3"
            />
            <h3 className="h5 fw-medium">{t('open_data')}</h3>
            <p className="small" style={{ textAlign: 'justify' }}>
              {t('open_data-subtitle')}
            </p>
            <Link className="nav-link" to="/GeospatialOpenData">
            <div className="read-more d-flex align-items-center justify-content-center mt-3 text-muted">
                <p className="mb-0">{t('read-more')}</p>
                <img src={arrowRightIcon} className="ms-2" alt="arrow right" />
              </div>                </Link>
           
          </div>

          {/* Card 3 */}
          <div className="service-card p-4 text-center shadow-sm mb-4" id="geospatialIncidence">
            <img
              src={globeIcon}
              alt={t('geospatial_incidences')}
              className="card-icon img-fluid mb-3"
            />
            <h3 className="h5 fw-medium">{t('geospatial_incidences')}</h3>
            <p className="small" style={{ textAlign: 'justify' }}>
              {t('geospatial_incidences-subtitle')}
            </p>
            <a
              href={t('geospatial-incidence-url')}
              className="card-link"
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="read-more d-flex align-items-center justify-content-center mt-3 text-muted">
                <p className="mb-0">{t('read-more')}</p>
                <img src={arrowRightIcon} className="ms-2" alt="arrow right" />
              </div>
            </a>
          </div>

          {/* Card 4 */}
          {/* <div className="service-card p-4 text-center shadow-sm mb-4" id="officialMap">
            <img
              src={ksaIcon}
              alt={t('ksa_official_map')}
              className="card-icon img-fluid mb-3"
            />
            <h3 className="h5 fw-medium">{t('ksa_official_map')}</h3>
            <p className="small" style={{ textAlign: 'justify' }}>
              {t('ksa_official_map-subtitle')}
            </p>
            <Link className="nav-link" to="/GeospatialOpenData/OfficialSaudiMap"
              href={t('ksa-official-map-url')}
              style={{ textDecoration: 'none' }}
              rel="noopener noreferrer"
            >
              <div className="read-more d-flex align-items-center justify-content-center mt-3 text-muted">
                <p className="mb-0">{t('read-more')}</p>
                <img src={arrowRightIcon} className="ms-2" alt="arrow right" />
              </div>
            </Link>
          </div> */}
        </div>

      </div>


      {/* Space for content below the cards */}
      <div className="cards-space" style={{height:"40px"}}></div>
      <section class="general-services">
     {/* <div class="general-service" >
        <div class="general-text" >
          <h3 data-key="Saudi_Map">{t('Saudi_Map')}</h3>
          <p data-key="Saudi_Map_subtitle1">{t('Saudi_Map_subtitle1')}</p>
          <p data-key="Saudi_Map_subtitle2">{t('Saudi_Map_subtitle2')}</p>
          <a data-href-key="ksa-map-url" href={t('ksa-map-url')} target="_blank" rel="noopener noreferrer"><button class="btn btn-white mt-3" data-key="read-more" id="KSAMAP">
          {t('read-more')}          </button></a>
        </div>
        <div class="general-img">
          <img src={ksaMap}  alt='gauge-network'/>
          <div class="overlay" ></div>
        </div>
      </div>*/}

      <div class="network-service" >
        <div class="general-text" >
          <h3 data-key="geocatalog">{t('geocatalog')}</h3>
          <p data-key="geocatalog_description" >{t('geocatalog_description')}</p>
          <a data-href-key="ksa-map-url" href="https://geocatalog.geoportal.sa/geonetwork" target="_blank" rel="noopener noreferrer"><button class="btn btn-white mt-3" data-key="read-more" id="Geocatalog">
          {t('read-more')}          </button></a> 
         {/* < Link className="nav-link" to="/national-geocatalog">
          <button className="btn btn-white mt-3">{t('read-more')}</button>
                  </Link> */}
          
        </div>
        <div class="general-img">
          <img src={geocatalog} alt=''/>
          <div class="right-overlay"></div>
        </div>
      </div>
    
     
    </section>

   
    <div className="cards-space" style={{height:"40px"}}></div>
    <section class="achievements" id="statistics">
       
        <section class="achievement-cards" >
          
          <div class="achievement-grid"  >
            <img class="rectangle" src={rectangle} alt='rectangle' />
            <img class="achievement-icon" src={gouv} alt='achievement'/>
            <p class="number">85+</p>
            <p class="achievement-text" data-key="gov_customer">
            {t('gov_customer')}
            </p>
            <p  data-key="customer">
            {t('customer')}
            </p>
          </div>
          <div class="achievement-grid">
            <img class="rectangle" src={rectangle} alt='rectangle'/>
            <img class="achievement-icon" src={priv} alt='achievement'/>
            <p class="number">55+</p>
            <p class="achievement-text" data-key="priv_customer">
            {t('priv_customer')}
            </p>
            <p  data-key="customer">
            {t('customer')}
            </p>
          </div>
          <div class="achievement-grid" >
            <img class="rectangle" src={rectangle} alt='rectangle'/>
            <img class="achievement-icon" src={academ} alt='achievement'/>
            <p class="number">20+</p>
            <p class="achievement-text" data-key="acad_customer">
            {t('acad_customer')}
            </p>
            <p  data-key="customer">
            {t('customer')}
            </p>
          </div>
       
          <div class="achievement-grid">
            <img class="rectangle" src={rectangle} alt='rectangle'/>
            <img class="achievement-icon" src={webser} alt='achievement-icon' />
            <p class="number">450+</p>
            <p class="achievement-text" data-key="web-services">
            {t('web-services')}
            </p>
          </div>
          <div class="achievement-grid">
            <img class="rectangle" src={rectangle} alt='rectangle'/>
            <img class="achievement-icon" src={data} alt='achievement-icon'/>
            <p class="number">1.6K+</p>
            <p class="achievement-text" data-key="data_request">
            {t('data_request')}
            </p>
          </div>
        </section>
      </section>

      
      <div className="cards-space" style={{height:"40px"}} ></div>
      
      
 
    <section class="services">
      <div class="service-card" id="geonames_description">
      <Link className="nav-link" to="/GeographicalNames">
      <div class="image-container">
          <img src={geonames} alt="Geographical Names" />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="geographical_names">{t('geographical_names')}</h3>
          </div>
        </div>                  </Link>
        
        <div class="text-container" >
          <p data-key="geographical_names-subtitle">
          {t('geographical_names-subtitle')}
          </p>
        </div>
      </div>
      <div class="service-card" id="sdg_description">
        <a data-href-key="ksa-sdgs-url" href={t('ksa-sdgs-url')} target="_blank" rel="noopener noreferrer" style={{textDecoration:'none'}}>
        <div class="image-container">
          <img
            src={opendata}
            alt="Open Geospatial Data For SDGs"
          />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="open_geospatial_data_for_sdgs">
            {t('open_geospatial_data_for_sdgs')}
            </h3>
          </div>
        </div></a>
        <div class="text-container" >
          <p data-key="open_geospatial_data_for_sdgs-subtitle">
          {t('open_geospatial_data_for_sdgs-subtitle')}
          </p>
        </div>
      </div>
      <div class="service-card" id="geodesy_description">
      <Link className="nav-link" to="/Geodesy">
        <div class="image-container">
          <img
            src={geodesy}
            alt="National Tide Gauge Network"
          />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="geodesy-sub">
            {t('geodesy-sub')}
            </h3>
          </div>
        </div></Link>
        <div class="text-container" >
          <p data-key="geodesy-subtitle">
          {t('geodesy-subtitle')}
          </p>
        </div>
      </div>

      <div class="service-card" id="digitaltwin_description">
      <Link className="nav-link" to="/DigitalTwin">
      <div class="image-container">
          <img
            src={dtwin}
            alt="digitalTwin"
          />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="digital-twin-sub">
            {t('digital-twin-sub')}            </h3>
          </div>
        </div>                </Link>

       
        <div class="text-container" >
          <p data-key="digital-twin-subtitle">
          {t('digital-twin-subtitle')} 
          </p>
        </div>
      </div>

      {/* <div class="service-card">
      <Link className="nav-link" to="/Maritime">
        <div class="image-container">
         <img
            src={maritime}
            alt="Hydrography Infrastucture"
          />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="hydro-sub">
            {t('hydro-sub')} 
            </h3>
          </div>
        </div></Link>
        <div class="text-container" >
          <p data-key="hydro-subtitle">
          {t('hydro-subtitle')} 
          </p>
        </div>
      </div> */}
    </section>

   
    <div className="cards-space" style={{height:"40px"}}></div>
    
    </>
  );
}

export default HeroSection;
